import React from 'react'
import { Paper, SxProps, Theme } from '@mui/material'

export default function ColorBox(props: {
  children: JSX.Element | JSX.Element[] | string | null
  sx?: SxProps<Theme>
}) {
  const { sx } = props
  return (
    <Paper
      variant='outlined'
      sx={{ ...sx, borderColor: '#ECEFF4', borderRadius: '16px', padding: 2 }}
      elevation={0}
    >
      {props.children}
    </Paper>
  )
}
